import React from 'react';
import optionsEmbeds from './utils/optionsEmbeds';
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';
import HyperLink from 'components/HyperLink';
import RichTextEmbeddedAsset from './components/RichTextEmbeddedAsset';
import RichTextParagraphBlock from './components/RichTextParagraphBlock';
import RichTextQuote from './components/RichTextQuote';
import Text from 'components/Text';
import { reduceContentValues } from 'utils/text';

const contentfulRichTextOptions = props => {
  const {
    dataPosition,
    textAlignment,
    alignmentDesktop,
    alignmentMobile,
    color,
    formType,
    headingSpacingDesktop,
    headingSpacingMobile,
    h1Size,
    h2Size,
    h3Size,
    h4Size,
    h5Size,
    h6Size,
    paragraphSize,
    paragraphSpacingDesktop,
    paragraphSpacingMobile,
    removeTextSpacing,
    ...otherProps
  } = props || {};

  const sharedTextProps = {
    textAlignment: textAlignment,
    alignDesktop: alignmentDesktop,
    alignMobile: alignmentMobile,
    color,
    removeTextSpacing,
    headingSpacingDesktop,
    headingSpacingMobile,
    paragraphSpacingDesktop,
    paragraphSpacingMobile,
  };

  return {
    renderMark: {
      [MARKS.BOLD]: text => (
        <span className="bold">
          <b>{text}</b>
        </span>
      ),
      [MARKS.ITALIC]: text => (
        <span className="bold">
          <em>{text}</em>
        </span>
      ),
      [MARKS.CODE]: text => {
        return <div dangerouslySetInnerHtml={{ __html: text }} />;
      },
    },
    renderNode: {
      [INLINES.HYPERLINK]: node => (
        <HyperLink href={node.data.uri}>{reduceContentValues(node?.content)}</HyperLink>
      ),
      [BLOCKS.HEADING_1]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h1'}
          size={h1Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h2'}
          size={h2Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.HEADING_3]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h3'}
          size={h3Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.HEADING_4]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h4'}
          size={h4Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.HEADING_5]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h5'}
          size={h5Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.HEADING_6]: (node, children) => (
        <Text
          type={otherProps?.overrideType || 'h6'}
          size={h6Size}
          {...otherProps}
          {...sharedTextProps}
        >
          {children}
        </Text>
      ),
      [BLOCKS.QUOTE]: (node, children) => <RichTextQuote {...otherProps}>{children}</RichTextQuote>,
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const styles = props?.styles;
        return optionsEmbeds(
          node,
          styles,
          alignmentDesktop,
          alignmentMobile,
          dataPosition,
          formType
        );
      },
      [BLOCKS.EMBEDDED_ASSET]: node => {
        return <RichTextEmbeddedAsset {...otherProps} node={node} />;
      },
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return otherProps.overrideType ? (
          <Text
            type={otherProps?.overrideType}
            size={paragraphSize}
            {...otherProps}
            {...sharedTextProps}
          >
            {children}
          </Text>
        ) : (
          <RichTextParagraphBlock
            node={node}
            size={paragraphSize}
            children={children}
            {...otherProps}
            {...sharedTextProps}
          />
        );
      },
    },
  };
};

export default contentfulRichTextOptions;
